import { EZIndexes } from '@/enums/EZIndexes';
import { cn } from '@/utils/utils_client';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';

interface Props extends React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Content> {
  className?: string;
  sideOffset?: number;
  trigger_id?: string;
}

export const UI_PRIMITIVE__dropdown_menu_content = forwardRef<React.ElementRef<typeof DropdownMenuPrimitive.Content>, Props>(
  ({ trigger_id, className, sideOffset = 4, ...props }, ref) => {
    /*
     * FIELDS
     */

    /*
     * EFFECTS
     */

    /*
     * HTML
     */
    return (
      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          {...{ ref, sideOffset }}
          className={cn(
            `${EZIndexes.DROPDOWN_MENU} 
            relative overflow-hidden p-1
            min-w-32
            !w-max
            rounded-md
            text-neutral-950
            dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-50
            
            border border-neutral-200 
            shadow-md
            data-[state=open]:animate-in 
            data-[state=open]:fade-in-0 
            data-[state=open]:zoom-in-95
            
            data-[state=closed]:animate-out 
            data-[state=closed]:fade-out-0 
            data-[state=closed]:zoom-out-95 
            
            data-[side=bottom]:slide-in-from-top-2 
            data-[side=left]:slide-in-from-right-2 
            data-[side=right]:slide-in-from-left-2 
            data-[side=top]:slide-in-from-bottom-2
            
            cursor-default`,
            className,
          )}
          {...props}
        />
      </DropdownMenuPrimitive.Portal>
    );
  },
);

UI_PRIMITIVE__dropdown_menu_content.displayName = DropdownMenuPrimitive.Content.displayName;
